"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BASE_CLASS_NAME = exports.PROJECT_LIST_ITEM_MARGIN_BOTTOM = exports.PROJECT_LIST_ITEM_HEIGHT = void 0;
var dashboard_empty_arrow_svg_1 = __importDefault(require("@ClientAssets/icons/brand/dashboard-empty-arrow.svg"));
var ProjectListItem_1 = __importDefault(require("../ProjectListItem/ProjectListItem"));
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var DragStore_1 = require("../Stores/DragStore");
var classnames_1 = __importDefault(require("classnames"));
var DeletedProjectListItem_1 = __importDefault(require("../ProjectListItem/DeletedProjectListItem"));
var GhostProjectListItem_1 = __importDefault(require("../ProjectListItem/GhostProjectListItem"));
var LayoutUtils_1 = require("./LayoutUtils");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var Telemetry_1 = require("Telemetry");
var StaggeredAnimation_1 = require("./StaggeredAnimation");
var kaleidoscope_3 = require("@qwilr/kaleidoscope");
var ReactCSSTransitionGroup = require("react-addons-css-transition-group");
var DashboardUtils_1 = require("Dashboard/DashboardUtils");
var DashboardTypes_1 = require("@CommonFrontendBackend/Dashboard/DashboardTypes");
var kaleidoscope_4 = require("@qwilr/kaleidoscope");
exports.PROJECT_LIST_ITEM_HEIGHT = 75;
exports.PROJECT_LIST_ITEM_MARGIN_BOTTOM = 8;
exports.BASE_CLASS_NAME = "project-layout";
var ListLayout = (function (_super) {
    __extends(ListLayout, _super);
    function ListLayout(props) {
        var _this = _super.call(this, props) || this;
        _this.previousButtonClicked = function () {
            _this.projectListStore.goPreviousPage();
            _this.scrollToTop();
        };
        _this.nextButtonClicked = function () {
            _this.projectListStore.goNextPage();
            _this.scrollToTop();
        };
        _this.scrollToTop = function () {
            if (!_this.shouldInfiniteScroll) {
                _this.props.dashboardRef.current.scrollTo(0, 0);
            }
        };
        _this.stopPropagation = function (event) { return event.stopPropagation(); };
        _this.renderEmptyState = function (currentCollection, areAnyFiltersSelected) {
            if (areAnyFiltersSelected) {
                return react_1.default.createElement(kaleidoscope_4.EmptyState, { isDashed: true, title: "We can’t find any pages that match your filters." });
            }
            switch (currentCollection) {
                case DashboardTypes_1.ProjectCollection.All:
                    return (react_1.default.createElement(kaleidoscope_4.EmptyState, { isDashed: true, title: "Create your first Qwilr Page", subtitle: "Click ‘Create New’ and select ‘Blank Page’ or ‘From Template’ to get started" },
                        react_1.default.createElement(kaleidoscope_2.SVG, { src: dashboard_empty_arrow_svg_1.default, className: "".concat(exports.BASE_CLASS_NAME, "__arrow") })));
                case DashboardTypes_1.ProjectCollection.Archived:
                    return react_1.default.createElement(kaleidoscope_4.EmptyState, { isDashed: true, title: "There’s nothing here!" });
                case DashboardTypes_1.ProjectCollection.Deleted:
                    return (react_1.default.createElement(kaleidoscope_4.EmptyState, { isDashed: true, title: "There’s nothing here!", subtitle: "Any deleted pages will be removed from your account after 30 days" }));
                default:
                    return react_1.default.createElement(kaleidoscope_4.EmptyState, { isDashed: true, title: "There’s nothing here!" });
            }
        };
        _this.recalculateSelection = function (_a) {
            var absoluteTop = _a.absoluteTop, absoluteLeft = _a.absoluteLeft, width = _a.width, height = _a.height;
            if (_this.projectListStore.isLoadingProjects ||
                _this.dragStore.dragType !== DragStore_1.DragType.Rectangle ||
                !_this.ref.current) {
                return;
            }
            var absoluteRight = absoluteLeft + width;
            var absoluteBottom = absoluteTop + height;
            var rect = _this.ref.current.getBoundingClientRect();
            var projectListLeft = rect.left;
            var projectListTop = rect.top;
            var projectListRight = rect.left + rect.width;
            _this.selectionStore.setSelecting((0, LayoutUtils_1.calculateSelectedListRange)(absoluteTop, absoluteRight, absoluteBottom, absoluteLeft, projectListLeft, projectListTop, projectListRight));
        };
        _this.renderDeletedProject = function (deletedProjectStore, index) {
            return (react_1.default.createElement(DeletedProjectListItem_1.default, { deletedProjectStore: deletedProjectStore, height: "".concat(exports.PROJECT_LIST_ITEM_HEIGHT, "px"), marginBottom: "".concat(exports.PROJECT_LIST_ITEM_MARGIN_BOTTOM, "px"), allowHoverState: !_this.dragStore.isDragging, onCheckboxClick: _this.handleListItemCheckboxClick(index), onRestoreClick: _this.handleRestoreClick(index), isSelected: _this.selectionStore.isSelected(index), isSelecting: _this.selectionStore.isSelecting(index), showMinimalActions: _this.props.numSelectedProjects > 0, onClick: function (event) { return _this.props.onResourceCardClick(event, index); }, onDragStart: function (event) { return _this.props.resourceDragStart(event, index); } }));
        };
        _this.renderProject = function (projectStore, index) {
            return (react_1.default.createElement(ProjectListItem_1.default, { projectStore: projectStore, dashboardViewStore: _this.props.dashboardViewStore, dashboardController: _this.dashboardController, height: "".concat(exports.PROJECT_LIST_ITEM_HEIGHT, "px"), marginBottom: "".concat(exports.PROJECT_LIST_ITEM_MARGIN_BOTTOM, "px"), allowHoverState: !_this.dragStore.isDragging, onCheckboxClick: _this.handleListItemCheckboxClick(index), onDeleteClick: function () { return _this.deleteItem(index); }, isSelected: _this.selectionStore.isSelected(index), isSelecting: _this.selectionStore.isSelecting(index), showMinimalActions: _this.props.numSelectedProjects > 0, onArchiveClick: function () { return _this.archiveItem(index); }, onViewChildren: function () { return _this.props.onViewChildrenClick(projectStore); }, onShareClick: function () { return _this.onShareClick(projectStore); }, onCloneClick: function () { return _this.onCloneClick(projectStore); }, applySelectionAnimation: _this.indexToApplySelectedAnimationOn === index, onClick: function (event) { return _this.props.onResourceCardClick(event, index); }, onDragStart: function (event) { return _this.props.resourceDragStart(event, index); }, isAdmin: _this.props.isAdmin }));
        };
        _this.onShareClick = function (projectStore) {
            _this.dashboardController.openMobileSharePopoverModal(projectStore);
        };
        _this.onCloneClick = function (projectStore) { return __awaiter(_this, void 0, void 0, function () {
            var Dashboard, DashboardFiltered;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Dashboard = Telemetry_1.ProjectCreatedCloneOrigin.Dashboard, DashboardFiltered = Telemetry_1.ProjectCreatedCloneOrigin.DashboardFiltered;
                        return [4, this.dashboardController.clone(projectStore, this.projectListStore.isFiltered ? DashboardFiltered : Dashboard)];
                    case 1:
                        _a.sent();
                        this.projectListStore.forceFetchProjects();
                        return [2];
                }
            });
        }); };
        _this.handleListItemCheckboxClick = function (clickedIndex) {
            return function (event) {
                if (event.shiftKey) {
                    _this.selectionStore.expandSelectionToIndex(clickedIndex);
                }
                else {
                    _this.selectionStore.toggleIndexSelected(clickedIndex);
                }
                _this.props.dashboardViewStore.closeProjectActionMenu();
            };
        };
        _this.handleRestoreClick = function (index) {
            return function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, this.projectListStore.restoreProjects([index])];
                        case 1:
                            _a.sent();
                            this.selectionStore.deselectAll();
                            return [2];
                    }
                });
            }); };
        };
        _this.startWatchingReactions = function () {
            _this.disposeDragReaction = (0, mobx_1.reaction)(function () {
                var _a = _this.props.dragStore, absoluteTop = _a.absoluteTop, absoluteLeft = _a.absoluteLeft, width = _a.width, height = _a.height;
                return { absoluteTop: absoluteTop, absoluteLeft: absoluteLeft, width: width, height: height };
            }, _this.recalculateSelection);
            _this.disposeSelectedReaction = (0, mobx_1.observe)((0, mobx_1.computed)(function () { return _this.selectionStore.selected; }), _this.onSelectionChange);
        };
        _this.stopWatchingReactions = function () {
            _this.disposeSelectedReaction && _this.disposeSelectedReaction();
            _this.disposeDragReaction && _this.disposeDragReaction();
        };
        _this.onSelectionChange = function (objectDidChange) {
            if (objectDidChange.type !== "update") {
                return;
            }
            var oldValue = objectDidChange.oldValue, newValue = objectDidChange.newValue;
            var noSelectionToOneItemSelected = oldValue.length === 0 && newValue.length === 1;
            if (noSelectionToOneItemSelected) {
                _this.indexToApplySelectedAnimationOn = newValue[0];
                setTimeout(function () {
                    _this.indexToApplySelectedAnimationOn = undefined;
                }, 150);
            }
            else {
                _this.indexToApplySelectedAnimationOn = undefined;
            }
        };
        _this.ref = react_1.default.createRef();
        _this.selectionStore = props.selectionStore;
        _this.dragStore = props.dragStore;
        _this.projectListStore = props.projectListStore;
        _this.dashboardController = props.dashboardController;
        return _this;
    }
    ListLayout.prototype.componentDidMount = function () {
        this.startWatchingReactions();
    };
    ListLayout.prototype.componentWillUnmount = function () {
        this.stopWatchingReactions();
    };
    ListLayout.prototype.render = function () {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "".concat(exports.BASE_CLASS_NAME, " ").concat(exports.BASE_CLASS_NAME, "--list"), ref: this.ref },
                react_1.default.createElement(ReactCSSTransitionGroup, { transitionLeave: true, transitionLeaveTimeout: kaleidoscope_3.AnimationDuration.Medium, transitionName: "project-list-transition", transitionEnter: false, component: react_1.default.Fragment }, this.projectListStore.isLoadingProjects ? this.renderGhosts() : this.renderProjects())),
            this.shouldInfiniteScroll ? this.renderInfiniteScrollPlaceholder() : this.renderPagination()));
    };
    ListLayout.prototype.renderInfiniteScrollPlaceholder = function () {
        var _this = this;
        if (this.projectListStore.isLoadingProjects || !this.projectListStore.hasNextResourcePage) {
            return;
        }
        return (react_1.default.createElement("div", { className: "".concat(exports.BASE_CLASS_NAME, "--next-page__pagination"), onMouseDown: this.stopPropagation },
            react_1.default.createElement("div", { onClick: function () { return _this.projectListStore.fetchResources(true); }, className: (0, classnames_1.default)("".concat(exports.BASE_CLASS_NAME, "__page-label"), "label", "label--large", "label--light") }, "Load next page")));
    };
    ListLayout.prototype.renderPagination = function () {
        if (this.projectListStore.isSinglePage || this.projectListStore.isLoadingProjects) {
            return;
        }
        return (react_1.default.createElement("div", { className: "".concat(exports.BASE_CLASS_NAME, "__pagination"), onMouseDown: this.stopPropagation },
            react_1.default.createElement(kaleidoscope_1.Pagination, { onPreviousButtonClick: this.previousButtonClicked, onNextButtonClick: this.nextButtonClicked, isPreviousButtonDisabled: !this.projectListStore.hasPreviousPage, isNextButtonDisabled: !this.projectListStore.hasNextPage },
                react_1.default.createElement("div", { className: (0, classnames_1.default)("".concat(exports.BASE_CLASS_NAME, "__page-label"), "label", "label--large", "label--light") }, "Page ".concat(this.projectListStore.pageNum + 1, " of ").concat(this.projectListStore.pageCount)))));
    };
    ListLayout.prototype.renderGhosts = function () {
        return (react_1.default.createElement("div", { key: "ghosts-staggered-transition" },
            react_1.default.createElement(StaggeredAnimation_1.StaggeredAnimation, { transitionName: "ghosts-staggered-transition", delayInMs: 50, transitionTimeoutInMs: kaleidoscope_3.AnimationDuration.Long, disableLeaveAnimation: true }, __spreadArray([], __read(Array(25).keys()), false).map(function (value, i) { return (react_1.default.createElement("div", { key: i },
                react_1.default.createElement(GhostProjectListItem_1.default, null))); }))));
    };
    ListLayout.prototype.renderProjects = function () {
        var _this = this;
        var _a = this.projectListStore, projectStores = _a.projectStores, selectedFolder = _a.selectedFolder, areAnyFiltersSelected = _a.areAnyFiltersSelected;
        if (!projectStores.length) {
            return this.renderEmptyState(selectedFolder, areAnyFiltersSelected);
        }
        return (react_1.default.createElement("div", null,
            this.projectListStore.selectedFolder === DashboardTypes_1.ProjectCollection.Deleted && (react_1.default.createElement(kaleidoscope_1.Alert, { heading: "NOTE", className: "".concat(exports.BASE_CLASS_NAME, "--delete-alert") }, "Deleted pages will be removed from your account after 30 days.")),
            react_1.default.createElement("div", { key: "projects-staggered-transition" },
                react_1.default.createElement(StaggeredAnimation_1.StaggeredAnimation, { transitionName: "projects-staggered-transition", delayInMs: 50, disableLeaveAnimation: true, transitionTimeoutInMs: kaleidoscope_3.AnimationDuration.Long }, projectStores.map(function (projectStore, i) {
                    var projectNode;
                    if (projectStore.type === "ProjectStore") {
                        projectNode = _this.renderProject(projectStore, i);
                    }
                    else {
                        projectNode = _this.renderDeletedProject(projectStore, i);
                    }
                    return react_1.default.createElement("div", { key: projectStore._id }, projectNode);
                })))));
    };
    ListLayout.prototype.deleteItem = function (index) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.projectListStore.deleteProjects([index])];
                    case 1:
                        _a.sent();
                        this.selectionStore.deselectAll();
                        this.props.dashboardViewStore.closeProjectActionMenu();
                        return [2];
                }
            });
        });
    };
    ListLayout.prototype.archiveItem = function (index) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.projectListStore.archiveProjects([index])];
                    case 1:
                        _a.sent();
                        this.props.dashboardViewStore.closeProjectActionMenu();
                        return [2];
                }
            });
        });
    };
    Object.defineProperty(ListLayout.prototype, "shouldInfiniteScroll", {
        get: function () {
            var selectedFolder = this.props.dashboardViewStore.folderSelectionViewStore.selectedFolder;
            return !!selectedFolder && !(0, DashboardUtils_1.isASystemFolder)(selectedFolder);
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Number)
    ], ListLayout.prototype, "indexToApplySelectedAnimationOn", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ListLayout.prototype, "shouldInfiniteScroll", null);
    ListLayout = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], ListLayout);
    return ListLayout;
}(react_1.default.Component));
exports.default = ListLayout;
